import React from 'react';
import { DivHeader } from './styles';
import { fieldsPropType } from './PropTypes';

function HeaderComponent({ fields }) {
  return (
    <>
      <DivHeader area="1 / payer">
        {fields.payer.label}
      </DivHeader>
      <DivHeader area="1 / kdb">
        {fields.kdb.label}
      </DivHeader>
      <DivHeader area="1 / proportion">
        {fields.proportion.label}
      </DivHeader>
      <DivHeader area="1 / dimension">
        {fields.dimension.label}
      </DivHeader>
      <DivHeader area="1 / is_basic">
        {fields.is_basic.label}
      </DivHeader>
    </>
  );
}

HeaderComponent.propTypes = {
  fields: fieldsPropType,
};

HeaderComponent.defaultProps = {
  fields: {},
};
export default HeaderComponent;
